export default __webpack_public_path__ + "static/pragicts-automation-services-network-automation-666bdcaf42f8f6a611115487f63e8017.jpg";